import React from "react";
import { useNavigate } from "react-router-dom";
import { CardContent, Typography, Box, Button } from "@mui/material";
import { IIssue } from "../../types/interfaces/IIssue";
import { useCphContext } from "../../hooks/useCphContext";
import { formatDateNumericDateAndHour } from "../../../global/utilities/DateFormatter";
import { DisplayParams } from "../../types/classes/DisplayParams";
import { useCphDataContext } from "../../hooks/useCphDataContext";

export default function IssueCard({
    issue,
    index,
    displayParams,
    onDisplayChange,
    onViewIssue
}: {
    issue: IIssue;
    index: number;
    displayParams: DisplayParams;
    onDisplayChange: (displayParams: DisplayParams) => void;
    onViewIssue: () => void;
}) {
    const { isStaff } = useCphContext();
    const { selectedIssue, setSelectedIssue } = useCphDataContext();

    const handleViewClick = () => {
        setSelectedIssue(issue);
        onViewIssue();
    };

    return (<>
        {issue && (
            <React.Fragment>
                <CardContent>
                    <Box sx={{ border: '1px solid', borderColor: 'grey.400', borderRadius: 1, p: 1, width: 240 }}>
                        <Typography
                            sx={{ fontSize: "0.8em", margin: "0, auto" }}
                            key={'issue_title'} display="block">
                            <span style={{ fontWeight: "bold" }}>Title: </span>
                            {issue.title}</Typography>
                        
                        {isStaff && (
                            <Typography
                                sx={{ fontSize: "0.8em", margin: "0, auto" }}
                                key={'staff_title'} display="block">
                                <span style={{ fontWeight: "bold" }}>Staff Note: </span>
                                {issue.staffTitle}</Typography>
                        )}
                        
                        <Typography
                            sx={{ fontSize: "0.8em", margin: "0, auto" }}
                            key={'reporter'} display="block">
                            <span style={{ fontWeight: "bold" }}>Issue Reporter: </span>
                            {issue.reporter?.lastName}, {issue.reporter?.firstName}</Typography>
                        
                        <Typography
                            sx={{ fontSize: "0.8em", margin: "0, auto" }}
                            key={'status'} display="block">
                            <span style={{ fontWeight: "bold" }}>Status: </span>
                            {issue.status?.status}</Typography>
                        
                        <Typography
                            sx={{ fontSize: "0.8em", margin: "0, auto" }}
                            key={'submit_date'} display="block">
                            <span style={{ fontWeight: "bold" }}>Submitted Date: </span>
                            {formatDateNumericDateAndHour(issue.status?.dateCreated)}</Typography>
                        
                        <Typography
                            sx={{ fontSize: "0.8em", margin: "0, auto" }}
                            key={'modified_date'} display="block">
                            <span style={{ fontWeight: "bold" }}>Last Modified Date: </span>
                            {formatDateNumericDateAndHour(issue.status?.lastModifiedDate || issue.status?.dateCreated)}</Typography>
                        
                        {isStaff && (
                            <Typography
                                sx={{ fontSize: "0.8em", margin: "0, auto" }}
                                key={'assigned_to'} display="block">
                                <span style={{ fontWeight: "bold" }}>Assigned To: </span>
                                {Array.isArray(issue.assignedTo) && issue.assignedTo.length > 0
                                    ? issue.assignedTo
                                        .map(person => `${person.firstName}${person.lastName ? ' ' + person.lastName : ''}`)
                                        .join(', ')
                                    : "Unassigned"}
                            </Typography>
                        )}
                        <Button
                            variant="contained"
                            size="small"
                            sx={{ mt: 1, ml: 1 }}
                            onClick={handleViewClick}>
                            View
                        </Button>
                    </Box>
                </CardContent>
            </React.Fragment>
        )}
    </>
    );
}